// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Card_cardWrapper__qu197","layer":"Card_layer__dSBNL"};